export const decode = (byteStream: BufferSource) => {
  const decoder = new TextDecoder();
  return decoder.decode(byteStream);
};
